import { render } from "./MultipleChoice.vue?vue&type=template&id=c16928ae"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__